var React = require('react');

function Flag (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-4.92 -2)"},[React.createElement("path",{"d":"M5.451,2a.531.531,0,0,0-.531.531V18.469a.531.531,0,0,0,1.063,0V2.531A.531.531,0,0,0,5.451,2Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M20.422,2.967a.531.531,0,0,0-.531,0,7.916,7.916,0,0,1-3.257.616,6.965,6.965,0,0,1-2.752-.792A6.789,6.789,0,0,0,11.231,2,5.769,5.769,0,0,0,9,2.452v9.111a4.675,4.675,0,0,1,2.258-.574,5.961,5.961,0,0,1,2.231.68,7.884,7.884,0,0,0,3.188.882,8.92,8.92,0,0,0,3.719-.728.531.531,0,0,0,.292-.473V3.418A.531.531,0,0,0,20.422,2.967Z","transform":"translate(-1.912)","fill":"currentColor","key":1})]));
}

Flag.defaultProps = {"width":"13.855","height":"17","viewBox":"0 0 13.855 17"};

module.exports = Flag;

Flag.default = Flag;
